<template>
  <div class="card-body activity-exam-marks">
    <div class="card height-auto v-application--is-ltr text-left">
      <div class="card-body">
        <v-row class="headerTable-div">
          <v-col md="4" sm="12">
            <p class="title main-color" style="text-align: left">
              {{ page_title }}
            </p>
          </v-col>
          <v-col md="6" sm="12"></v-col>
          <v-col md="2" sm="12">
            <v-btn
              class="modal-btn-save btn-outline"
              v-if="students.length > 0"
              @click="generateReport"
              :loading="loading"
              :disabled="loading"
              >{{ $t("Bulk Report Card") }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row class="mb-7">
          <v-col md="6" sm="12">
            <!-- Semester/Quarter -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Semester</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('semester')"
                  :items="semesters"
                  item-text="name"
                  item-value="id"
                  v-model="selectedSemester"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>

            <!-- Grades -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Grades</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Grade')"
                  :items="grades"
                  item-text="grade_name"
                  item-value="id"
                  v-model="selectedGrade"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="6" cols="12">
            <!-- Quarters -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Quarter</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Quarters')"
                  :items="quarters"
                  item-text="name"
                  item-value="id"
                  v-model="selectedQuarter"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>

            <!-- Class -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Class</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Class')"
                  :items="classes"
                  item-text="name"
                  item-value="id"
                  v-model="selectedClass"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider
          style="background-color: #ddd !important; margin-bottom: 20px"
          class="mt-4 mb-4 main-color"
        ></v-divider>
        <!-- <div class="text-right pt-2">
          <v-btn
            v-if="students.length > 0"
            class="modal-btn-save saveBtn text-capitalize"
            @click="show_approve_all_dialog = true"
            large
          >
            {{ $t("Approve All") }}
          </v-btn>
        </div> -->
        <v-row>
          <div class="card-body">
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="students"
              item-key="id"
              :show-select="false"
              class="elevation-1 level1 templates font-weight-light"
              text="left"
              hide-default-header
              hide-default-footer
              disable-pagination
            >
              <!-- Student headers -->
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr class="elevation-0">
                    <th
                      v-for="(headerItem, index) in headers"
                      :key="index"
                      style="text-wrap: nowrap"
                      :style="{
                        'text-align-last':
                          headerItem.value == 'name' ? 'left' : ' center',
                      }"
                    >
                      <p
                        class="mb-0"
                        v-if="
                          headerItem.value == 'name' ||
                          headerItem.value ==
                            'student_subjects_total_mark_percentage' ||
                          headerItem.value == 'printPdf' ||
                          headerItem.value == 'approved'
                        "
                        @click="changeSort(headerItem.value)"
                      >
                        {{ headerItem.text }}
                        <v-icon
                          small
                          v-if="
                            headerItem.value != 'approved' &&
                            headerItem.value != 'printPdf' &&
                            (Object.keys(options).length === 0 ||
                              options.sortDesc == false)
                          "
                          >mdi-arrow-up</v-icon
                        >
                        <v-icon
                          small
                          v-else-if="
                            headerItem.value != 'approved' &&
                            headerItem.value != 'printPdf' &&
                            options.sortDesc == true
                          "
                          >mdi-arrow-down</v-icon
                        >
                      </p>
                      <p
                        class="mb-0"
                        v-else-if="headerItem.value == 'student_total_mark'"
                      >
                        {{ headerItem.text }} <br />
                        <span class="mb-0 small font-weight-bold">
                          ( {{ headerItem.full_mark }} )
                        </span>
                      </p>

                      <router-link
                        v-else
                        :to="
                          '/performance/confirmed-marks/' +
                          selectedQuarter +
                          '/' +
                          selectedClass +
                          '/' +
                          headerItem.academic_grade_subject_id
                        "
                      >
                        {{ headerItem.text }}
                        <p class="mb-0 small font-weight-bold">
                          ( {{ headerItem.subject_full_mark }} )
                        </p>
                      </router-link>
                    </th>
                  </tr>
                </thead>
              </template>

              <!-- Student Data -->
              <template v-slot:item="{ item }">
                <tr class="elevation-0">
                  <td
                    v-for="(itemData, propertyName, index) in item"
                    :key="index"
                    style="text-wrap: nowrap"
                    :style="{
                      'text-align-last':
                        propertyName == 'name' ? 'left' : ' center',
                    }"
                    v-if="propertyName != 'student_id'"
                  >
                    <v-row
                      :class="{
                        'justify-content-center': propertyName != 'name',
                      }"
                    >
                      <!-- Student Name -->
                      <p
                        class="mb-0 text-13 font-semibold"
                        v-if="propertyName == 'name'"
                      >
                        {{ itemData }}
                      </p>

                      <!-- Student Dynamic Data (Marks) -->
                      <p
                        class="mb-0"
                        :style="{
                          color:
                            itemData == ''
                              ? 'orange'
                              : itemData.studentHasUnconfirmedMarks
                              ? 'red'
                              : itemData.studentHasExamsWithNoMarks
                              ? 'blue'
                              : '',
                        }"
                        v-else-if="
                          propertyName != 'name' &&
                          propertyName != 'student_total_mark' &&
                          propertyName !=
                            'student_subjects_total_mark_percentage' &&
                          propertyName != 'approved'
                        "
                      >
                        {{ itemData.mark }}
                      </p>

                      <!-- Student Total Mark -->
                      <p
                        class="mb-0"
                        v-else-if="propertyName == 'student_total_mark'"
                      >
                        {{ itemData }}
                      </p>

                      <!-- Student Subject Total Mark Percentage -->
                      <p
                        class="mb-0"
                        v-else-if="
                          propertyName ==
                          'student_subjects_total_mark_percentage'
                        "
                      >
                        {{ itemData }}
                      </p>

                      <!-- Actions  (approve)-->
                      <v-icon
                        class="main-color ml-4"
                        style="align-self: center"
                        @click="printReportCard(item.student_id)"
                        v-if="propertyName == 'printPdf'"
                        :title="$t('Report Card')"
                      >
                        print
                      </v-icon>

                      <p
                        v-else-if="
                          propertyName == 'approved' &&
                          CanApprove &&
                          !item.approved
                        "
                        class="main-color align-center"
                        style="cursor: pointer; align-self: end"
                        @click="
                          item.studentHasUnconfirmedMarks
                            ? showMessage(item)
                            : ApproveStudent(item.student_id)
                        "
                      >
                        {{ $t("Approve") }}
                      </p>
                      <p
                        v-else-if="
                          propertyName == 'approved' &&
                          CanUnApprove &&
                          item.approved
                        "
                        class="main-color align-center"
                        style="cursor: pointer; align-self: end"
                        @click="UnApproveStudent(item.student_id)"
                      >
                        {{ $t("Unapprove") }}
                      </p>
                    </v-row>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-row>
      </div>
    </div>

    <v-snackbar
      v-model="snack"
      :timeout="snackTime"
      :color="snackColor"
      :right="true"
      :top="true"
    >
      <!-- {{ snackText }} -->

      <span class="white--text">{{ snackText }}</span>

      <v-btn text @click="snack = false">{{ $t("Close") }}</v-btn>
    </v-snackbar>

    <v-dialog
      v-model="show_approve_warning_msg"
      persistent
      max-width="320"
      class="dialog_confirm"
    >
      <v-card>
        <v-card-title class="headline">{{
          $t("Confirmation Message")
        }}</v-card-title>

        <v-card-text
          >{{ selectedStudent.name }}
          {{
            $t("has unconfirmed mark(s). Are you sure you want to approve?")
          }}</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="modal-btn-cancel noBtn"
            @click="cancelShowDialog()"
            id="noBtn"
            ref="always_focus"
            >{{ $t("Cancel") }}</v-btn
          >
          <v-btn
            id="yesBtn"
            @click="ApproveStudent(selectedStudent.student_id)"
            class="modal-btn-save yesBtn"
            >{{ $t("Yes") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";

import { validationMixin } from "../../mixins/validationMixin";
import ACL from "../../acl";
export default {
  name: "ConfirmedMarks",
  // components: { addEditExamComponent },
  mixins: [validationMixin],
  data() {
    return {
      options: {},
      // page: 1,
      // length: "",
      // totalVisible: "",
      // totalItems: "",
      CanApprove: ACL.checkPermission("approve-marks"),
      CanUnApprove: ACL.checkPermission("unapprove-marks"),
      selectedStudent: "",
      show_approve_warning_msg: false,
      valid: false,
      loading: false,
      snackTime: 3000,
      snackColor: "success",
      snackText: "",
      snack: false,
      page_title: "Semester Marks",
      selectedSemester: "",
      selectedQuarter: "",
      selectedGrade: "",
      selectedClass: "",
      semesters: [],
      quarters: [],
      grades: [],
      classes: [],
      headers: [],
      students: [],
      search: "",
      errorEmptyItems: "",
      // selected: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.getClassStudents();
      },
      deep: true,
    },
    selectedSemester: {
      handler() {
        this.getQuarters();
      },
      deep: true,
    },
    selectedQuarter: {
      handler() {
        this.getGrades();
      },
      deep: true,
    },
    selectedGrade: {
      handler() {
        this.getGradeClasses();
      },
      deep: true,
    },
    selectedClass: {
      handler() {
        if (this.selectedClass != "" && this.selectedClass != "all_class") {
          this.getClassStudents();
        } else if (this.selectedClass == "all_class") {
          this.students = [];
        }
      },
      deep: true,
    },
  },

  methods: {
    printReportCard(studentId) {
      axios
        .get(
          this.getApiUrl +
            "/performance/print-student-report-card/" +
            this.selectedQuarter +
            "/" +
            studentId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            let printLink = response.data.data;
            window.open(printLink, "_blank");
          }
        })
        .catch((err) => {
          alert(err);
        });
    },

    changeSort(column) {
      if (column != "approved" && column != "printPdf")
        this.options = { sortBy: column, sortDesc: !this.options.sortDesc };
    },
    cancelShowDialog() {
      this.selectedStudent = "";
      this.show_approve_warning_msg = false;
    },
    showMessage(item) {
      this.selectedStudent = item;
      this.show_approve_warning_msg = true;
    },
    ApproveStudent(student_id) {
      console.log(student_id);
      axios
        .get(
          this.getApiUrl +
            "/performance/approve-student-mark/" +
            this.selectedQuarter +
            "/" +
            student_id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then(() => {
          this.getClassStudents();
          this.cancelShowDialog();
        });
    },
    UnApproveStudent(student_id) {
      axios
        .get(
          this.getApiUrl +
            "/performance/un-approve-student-mark/" +
            this.selectedQuarter +
            "/" +
            student_id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then(() => {
          this.getClassStudents();
        });
    },
    confirmAllStudentsExamsMarks() {
      axios
        .post(
          this.getApiUrl +
            "/performance/approve-all-students-marks/" +
            this.selectedQuarter,
          {
            students: this.students,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then(() => {
          this.show_approve_all_dialog = false;
          this.getClassStudents();
        });
    },
    getSemesters() {
      axios
        .get(this.getApiUrl + "/performance/getSemestersFilter", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.semesters = response.data.data;
          this.semesters.forEach((semester) => {
            if (semester.isCurrentSemesterId) {
              this.selectedSemester = semester.id;
            }
          });
          this.selectedQuarter = "";
          this.selectedClass = "";
          this.quarters = [];
          this.grades = [];
          this.classes = [];
          this.students = [];
          this.headers = [];
        });
    },

    getQuarters() {
      axios
        .get(
          this.getApiUrl +
            "/performance/getQuarterFilterBySemester/" +
            this.selectedSemester,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((response) => {
          this.quarters = response.data.data;
          this.quarters.forEach((quarter) => {
            if (quarter.isCurrentQuarterId) {
              this.selectedQuarter = quarter.id;
            }
          });
          this.selectedClass = "";
          this.grades = [];
          this.classes = [];
          this.headers = [];
          this.students = [];
        });
    },

    getGrades() {
      if (this.selectedQuarter != "") {
        // performance/getGradesByRole/{quarterId}
        axios
          .get(
            this.getApiUrl +
              "/performance/getGradesByRole/" +
              this.selectedQuarter,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.grades = response.data.data;
            this.selectedGrade = "";
            this.selectedClass = "";
            this.classes = [];
            this.headers = [];
            this.students = [];
            this.errorEmptyItems = false;
          });
      }
    },

    getGradeClasses() {
      if (this.selectedGrade != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getGradeClasses/" +
              this.selectedGrade +
              "?all_classes=false",
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            this.classes = response.data.data;
            this.selectedClass = "";
            this.students = [];
            this.headers = [];
            this.errorEmptyItems = false;
          });
      }
    },
    generateReport() {
      this.loading = true;
      axios
        .get(
          this.getApiUrl +
            "/performance/semester-marks/collective-report/" +
            this.selectedSemester +
            "/" +
            this.selectedQuarter +
            "/" +
            this.selectedGrade,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            this.loading = false;
            let printLink = response.data.data;
            window.open(printLink, "_blank");
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    getClassStudents() {
      if (this.selectedClass != "") {
        this.loading = true;
        let sort_desc = "";
        let column = "";
        if (this.options.sortBy && this.options.sortBy) {
          column = this.options.sortBy;
          sort_desc = this.options.sortDesc;
        }

        axios
          .get(
            this.getApiUrl +
              "/performance/getConfirmedMarksData/" +
              this.selectedQuarter +
              "/" +
              this.selectedGrade +
              "/" +
              this.selectedClass +
              "?sort_desc=" +
              sort_desc +
              "&column=" +
              column,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            this.loading = false;
            this.students = [];
            // the first column (header data)
            this.headers = [
              {
                text: " Student Name",
                value: "name",
                sortable: true,
                align: "center",
              },
            ];
            this.headers = response.data.data.headers;
            /*
             * every classStudent is the data of every row in the table
             * every row is object consists of keys of subjects with their values every value is equal to the mark of student
             * and key of the name with its value is equal to the student name
             */
            this.students = response.data.data.classStudents;
          });
      }
    },
  },
  mounted() {
    this.getSemesters();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

// end search input
.title-page {
  margin-top: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.card-container {
  max-width: 80%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 50px;
}
.actions-container {
  position: relative;
}
.actions {
  position: absolute;
  top: -10px;
  right: 22px;
}
.actions i,
.actions span {
  cursor: pointer;
}
.actions span {
  margin-left: 5px;
}

.title-qualifire .divider {
  margin-top: 10px;
  margin-bottom: 10px;
}
.q-box-title {
  font-size: 29px;
  position: relative;
}

.q-box-title h2 {
  font-size: 25px;
  padding: 0;
  margin: 0;
}

.title-page {
  margin-top: 15px;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #eef3ff;
  margin-bottom: 33px;
}
.v-expansion-panel-content {
  background-color: #f7f7f7;
}
.title-panel {
  color: rgb(114, 151, 255);
  margin: 0;
  margin-top: 15px;
  padding: 0;
}
.details {
  margin-top: 6%;
  overflow: hidden;
}
.details span {
  color: #8d8a8a;
  font-size: 17px;
  font-weight: 700;
}
.details span.passing {
  float: right;
}
.v-expansion-panel-content__wrap {
  padding: 0;
}
.space-name {
  margin-top: -15px !important;
}

.betweencolon {
  position: absolute;
  top: 3rem;
  left: 5%;
}

.dur-error {
  margin-top: 0 !important;
}
.maxSize {
  font-size: 10px;
}
.text-left,
.text-left th,
.text-left td {
  text-align: left !important;
}
</style>
